/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { PageSlugProps } from "@cosmos/next-common";
import { Metadata } from "next";
import { notFound } from "next/navigation";

import { GetAppMetadata } from "../common";
import { cosmosPageBlogDetailMetadata } from "../cosmos-blog-detail";
import { cosmosPageEulaKeyMetadata } from "../cosmos-eula-key";
import { cosmosPageHeroAndSectionMetadata } from "../cosmos-hero-and-sections";
import { cosmosPageLegalContentMetadata } from "../cosmos-legal-content";
import { cosmosRedirectPage } from "../cosmos-redirect/CosmosRedirectPage.page";
import { cosmosPageResearchMetadata } from "../cosmos-research/CosmosPageResearch.data";
import { cosmosPageSearchMetadata } from "../cosmos-search";

import { checkValidParams, getKey } from "./selector";

export const metadataSelector = async (
	props: PageSlugProps,
	hygraphLocales: string[],
	getAppMetadata: GetAppMetadata,
): Promise<Metadata> => {
	const valid = checkValidParams(props);
	if (!valid) {
		return notFound();
	}

	const key = await getKey(props, hygraphLocales);

	if (!key) {
		return notFound();
	}

	//set root slug to empty string
	const slug = "";

	switch (key) {
		case "cosmosPageBlogDetail": {
			return cosmosPageBlogDetailMetadata({ ...props, slug, hygraphLocales, getAppMetadata });
		}
		case "cosmosPageEulaKey": {
			return cosmosPageEulaKeyMetadata({ ...props, slug, hygraphLocales, getAppMetadata });
		}
		case "cosmosPageLegalContent": {
			return cosmosPageLegalContentMetadata({ ...props, slug, hygraphLocales, getAppMetadata });
		}
		case "cosmosPageRedirect": {
			return cosmosRedirectPage(props);
		}
		case "cosmosPageSearch": {
			return cosmosPageSearchMetadata({ ...props, slug, hygraphLocales, getAppMetadata });
		}
		case "cosmosPageResearch": {
			return cosmosPageResearchMetadata({ ...props, slug, hygraphLocales, getAppMetadata });
		}
		default:
			return cosmosPageHeroAndSectionMetadata({ ...props, slug, hygraphLocales, getAppMetadata });
	}
};
